import { message } from "antd";
import api from "common/api";
import { INews } from "common/types/news";
import React, {
  FC,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { useNavigate, useParams } from "react-router-dom";

const Context = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState<INews>();
  const [loading, setLoading] = useState(false);

  const getById = async (id: string) => {
    try {
      setLoading(true);
      const response = await api.news.getById(id);
      setData(response.data);
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDelete = async () => {
    if (id)
      try {
        const response = await api.news.delete(id);
        message.success("Yangilik o'chirildi");
        navigate(-1);
      } catch (err) {
        console.log(err);
      }
    else navigate(-1);
  };

  useEffect(() => {
    if (id) getById(id);
  }, []);
  return {
    state: { data, loading },
    actions: { handleDelete },
  };
};

const NewsInfoContext = createContext<any>({ state: {}, actions: {} });

export const NewsInfoContextProvider: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const value = Context();
  return (
    <NewsInfoContext.Provider value={value}>
      {children}
    </NewsInfoContext.Provider>
  );
};

export default function useNewsInfoContext() {
  return useContext<ReturnType<typeof Context>>(NewsInfoContext);
}
